import React, { useEffect } from 'react';
import Table from '../../../modules/components/Table'
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddEditOrderStatus from './AddEditOrderStatus';
import firebase from "firebase";

export default function Index(props) {

    const [headCells, setHeadCells] = React.useState([]);
    const [headMobileCells, setHeadMobileCells] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState("");
    const [searchCell, setSearchCell] = React.useState([]);
    const [displayInfo, setDisplayInfo] = React.useState([]);
    const [editCells, setEditCells] = React.useState([]);
    const [addCells, setAddCells] = React.useState([]);
    const [addCellsName, setAddCellsName] = React.useState([]);
    const matches = useMediaQuery(theme => theme.breakpoints.up('sm'));

    useEffect(() => {

        setHeadCells([
            { id: 'name', label: 'Name' },
            { id: 'serial', label: 'Serial' }
        ])

        setHeadMobileCells([
            { id: 'name', label: 'Name' },
        ])
    
        setSearchCell([
            { id: 'id', label: 'ID' },
            { id: 'name', label: 'Name' },
            { id: 'serial', label: 'Serial' },
        ])

        setDisplayInfo([
            { id: 'id', label: 'ID' },
            { id: 'name', label: 'Name' },
            { id: 'serial', label: 'Serial' },
            { id: 'created', label: 'Created' }
        ])

        setEditCells([
            { id: 'name', label: 'Name' },
            { id: 'serial', label: 'Serial' }
        ])

        setAddCells([
            { id: 'name', label: 'Name' },
            { id: 'serial', label: 'Serial' }
        ])

        setAddCellsName({ 
            name: '', 
            created: firebase.database.ServerValue.TIMESTAMP,
            updated: firebase.database.ServerValue.TIMESTAMP,
            serial: null
         })
    
        setSearchValue("name")
        
    }, []);

    return (
    <Grid>
        <Table 
             {...props}
            order={'asc'}
            control={true}
            disabledMove={true}
            customizeDialog={AddEditOrderStatus}
            orderBy="serial" 
            data="orders_status" 
            addItemButton={true}
            addItemText="Add Order Status"
            addItemIcon={<AddCircleIcon/>}
            addCells={addCells}
            addCellsName={addCellsName}
            folder_data="orders_status_zone"
            displayInfo={displayInfo}
            editCells={editCells}
            matches={matches}
            headCells={matches ? headCells : headMobileCells} 
            searchValue={searchValue} 
            searchCell={searchCell}/>
    </Grid>
    )

}
  